import { render, staticRenderFns } from "./packageHistory.vue?vue&type=template&id=677df004&scoped=true&"
import script from "./packageHistory.vue?vue&type=script&lang=js&"
export * from "./packageHistory.vue?vue&type=script&lang=js&"
import style0 from "./packageHistory.vue?vue&type=style&index=0&id=677df004&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677df004",
  null
  
)

export default component.exports